import type { InjectionKey } from 'vue';

interface IMenuProvider {
  register(): void;
  unregister(): void;
  closeParents(): void;
}

export const CdsMenuSymbol: InjectionKey<IMenuProvider> = Symbol.for('cds:menu');

export const MENU_OPEN_DELAY = 300;
export const MENU_CLOSE_DELAY = 250;
